/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IClient {
    /**
     * Processes a Bill of Lading Payment
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The request.
     * @return Success
     */
    billofladingPayments(authorization: string, body: ExecuteBillOfLadingPaymentRequest | undefined): Promise<BillOfLadingPaymentResponse>;
    /**
     * Gets the Bill of Lading payments.
     * @param userId (optional) The id of the user who made the payment.
     * @param pageSize (optional) Gets or sets the size of the page. Defaults to 10.
     * @param pageIndex (optional) Gets or sets the zero-based page index. Default to 0.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getBillOfLadingPayments(userId: string | null | undefined, pageSize: number | null | undefined, pageIndex: number | null | undefined, authorization: string): Promise<PaymentSummaryDtoPagedResult>;
    /**
     * Processes a Bill of Lading payment via 3d Secure.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The request.
     * @return Success
     */
    threeDSecure(authorization: string, body: CompleteThreeDSecureBolPaymentRequest | undefined): Promise<BillOfLadingPaymentResponse>;
    /**
     * Gets the Bill of Lading payment by Payment Reference Number.
     * @param paymentReferenceNumber The payment reference number.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getBillOfLadingPayment(paymentReferenceNumber: string | null, authorization: string): Promise<GetBillOfLadingPaymentResponse>;
    /**
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) 
     * @return Success
     */
    completeBillPayment(authorization: string, body: CompleteThreeDSecurePaymentRequest | undefined): Promise<BillPaymentResponse>;
    /**
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) 
     * @return Success
     */
    beginBillPayment(authorization: string, body: BeginBillPaymentRequest | undefined): Promise<BeginBillPaymentResponse>;
    /**
     * Registers a credit card.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The credit card details
     * @return Success
     */
    beginRegisterCreditCard(authorization: string, body: BeginRegisterCreditCardRequest | undefined): Promise<BeginRegisterCreditCardResponse>;
    /**
     * Gets the credit card registrations by user ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getCreditCardRegistrations(userId: string, authorization: string): Promise<CreditCardRegistrationDto[]>;
    /**
     * Gets the credit card registration by ID.
     * @param id The registration id
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getSingleCreditCardRegistration(id: number, authorization: string): Promise<CreditCardRegistrationDto>;
    /**
     * Gets the credit card registration by ID.
     * @param id The registration id
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    creditcardRegistrations(id: number, authorization: string): Promise<CreditCardRegistrationDto>;
    /**
     * Deletes the credit card registration by ID.
     * @param id The registration ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    deleteCreditCardRegistration(id: number, authorization: string): Promise<void>;
    /**
     * Confirms the credit card registration by providing the random amount that was charged.
     * @param id The registration ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The request body containing the amount charged.
     * @return Success
     */
    confirmCreditCardRegistration(id: number, authorization: string, body: ConfirmCreditCardRegistrationRequestBody | undefined): Promise<void>;
    /**
     * Updates the credit card billing address.
     * @param id registration ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The billing address.
     * @return Success
     */
    updateCreditCardBillingAddress(id: number, authorization: string, body: AddressDto | undefined): Promise<void>;
    /**
     * @return Success
     */
    notifications(): Promise<string>;
    /**
     * Gets the list of supported credit card types.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    creditcardTypes(authorization: string): Promise<ReferenceValueDto[]>;
    /**
     * Gets the list of supported credit card currencies.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    creditcardCurrencies(authorization: string): Promise<ReferenceValueDto[]>;
    /**
     * Web Hook that is called by the 3DS authenticating bank
    with the result of the user's 3DS authentication, that was captured during credit card payment
     * @param paRes (optional) 
     * @param mD (optional) 
     * @return Success
     */
    authentication(paRes: string | undefined, mD: string | undefined): Promise<string>;
    /**
     * @param cashierId (optional) 
     * @param merID (optional) 
     * @param acqID (optional) 
     * @param orderID (optional) 
     * @param responseCode (optional) 
     * @param reasonCode (optional) 
     * @param reasonCodeDesc (optional) 
     * @param referenceNo (optional) 
     * @param paddedCardNo (optional) 
     * @param authCode (optional) 
     * @param cVV2Result (optional) 
     * @param shipToFirstName (optional) 
     * @param shipToLastName (optional) 
     * @param shipToAddress1 (optional) 
     * @param shipToAddress2 (optional) 
     * @param shipToCity (optional) 
     * @param shipToState (optional) 
     * @param shipToCountry (optional) 
     * @param shipToTelephone (optional) 
     * @param shipToEMail (optional) 
     * @param billToFirstName (optional) 
     * @param billToLastName (optional) 
     * @param billToAddress1 (optional) 
     * @param billToAddress2 (optional) 
     * @param billToCity (optional) 
     * @param billToState (optional) 
     * @param billToCountry (optional) 
     * @param billToTelephone (optional) 
     * @param billToEMail (optional) 
     * @param originalResponseCode (optional) 
     * @param signature (optional) 
     * @param signatureMethod (optional) 
     * @param tokenizedPAN (optional) 
     * @return Success
     */
    verifyPayment(cashierId: string | null | undefined, merID: string | null | undefined, acqID: string | null | undefined, orderID: string | null | undefined, responseCode: string | null | undefined, reasonCode: string | null | undefined, reasonCodeDesc: string | null | undefined, referenceNo: string | null | undefined, paddedCardNo: string | null | undefined, authCode: string | null | undefined, cVV2Result: string | null | undefined, shipToFirstName: string | null | undefined, shipToLastName: string | null | undefined, shipToAddress1: string | null | undefined, shipToAddress2: string | null | undefined, shipToCity: string | null | undefined, shipToState: string | null | undefined, shipToCountry: string | null | undefined, shipToTelephone: string | null | undefined, shipToEMail: string | null | undefined, billToFirstName: string | null | undefined, billToLastName: string | null | undefined, billToAddress1: string | null | undefined, billToAddress2: string | null | undefined, billToCity: string | null | undefined, billToState: string | null | undefined, billToCountry: string | null | undefined, billToTelephone: string | null | undefined, billToEMail: string | null | undefined, originalResponseCode: string | null | undefined, signature: string | null | undefined, signatureMethod: string | null | undefined, tokenizedPAN: string | null | undefined): Promise<VerifyFirstAtlanticPaymentResponse>;
    /**
     * @param merID (optional) 
     * @param acqID (optional) 
     * @param orderID (optional) 
     * @param responseCode (optional) 
     * @param tokenizedPAN (optional) 
     * @param reasonCode (optional) 
     * @param reasonCodeDesc (optional) 
     * @param referenceNo (optional) 
     * @param paddedCardNo (optional) 
     * @param authCode (optional) 
     * @param cVV2Result (optional) 
     * @param shipToFirstName (optional) 
     * @param shipToLastName (optional) 
     * @param shipToAddress1 (optional) 
     * @param shipToAddress2 (optional) 
     * @param shipToCity (optional) 
     * @param shipToState (optional) 
     * @param shipToCountry (optional) 
     * @param shipToTelephone (optional) 
     * @param shipToEMail (optional) 
     * @param billToFirstName (optional) 
     * @param billToLastName (optional) 
     * @param billToAddress1 (optional) 
     * @param billToAddress2 (optional) 
     * @param billToCity (optional) 
     * @param billToState (optional) 
     * @param billToCountry (optional) 
     * @param billToTelephone (optional) 
     * @param billToEMail (optional) 
     * @param originalResponseCode (optional) 
     * @param signature (optional) 
     * @param signatureMethod (optional) 
     * @return Success
     */
    verifyCard(merID: string | null | undefined, acqID: string | null | undefined, orderID: string | null | undefined, responseCode: string | null | undefined, tokenizedPAN: string | null | undefined, reasonCode: string | null | undefined, reasonCodeDesc: string | null | undefined, referenceNo: string | null | undefined, paddedCardNo: string | null | undefined, authCode: string | null | undefined, cVV2Result: string | null | undefined, shipToFirstName: string | null | undefined, shipToLastName: string | null | undefined, shipToAddress1: string | null | undefined, shipToAddress2: string | null | undefined, shipToCity: string | null | undefined, shipToState: string | null | undefined, shipToCountry: string | null | undefined, shipToTelephone: string | null | undefined, shipToEMail: string | null | undefined, billToFirstName: string | null | undefined, billToLastName: string | null | undefined, billToAddress1: string | null | undefined, billToAddress2: string | null | undefined, billToCity: string | null | undefined, billToState: string | null | undefined, billToCountry: string | null | undefined, billToTelephone: string | null | undefined, billToEMail: string | null | undefined, originalResponseCode: string | null | undefined, signature: string | null | undefined, signatureMethod: string | null | undefined): Promise<VerifyFirstAtlanticPaymentResponse>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Processes a Bill of Lading Payment
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The request.
     * @return Success
     */
    billofladingPayments(authorization: string, body: ExecuteBillOfLadingPaymentRequest | undefined , cancelToken?: CancelToken | undefined): Promise<BillOfLadingPaymentResponse> {
        let url_ = this.baseUrl + "/v1/billoflading-payments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBillofladingPayments(_response);
        });
    }

    protected processBillofladingPayments(response: AxiosResponse): Promise<BillOfLadingPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillOfLadingPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = BillOfLadingPaymentResponse.fromJS(resultData201);
            return result201;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillOfLadingPaymentResponse>(<any>null);
    }

    /**
     * Gets the Bill of Lading payments.
     * @param userId (optional) The id of the user who made the payment.
     * @param pageSize (optional) Gets or sets the size of the page. Defaults to 10.
     * @param pageIndex (optional) Gets or sets the zero-based page index. Default to 0.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getBillOfLadingPayments(userId: string | null | undefined, pageSize: number | null | undefined, pageIndex: number | null | undefined, authorization: string , cancelToken?: CancelToken | undefined): Promise<PaymentSummaryDtoPagedResult> {
        let url_ = this.baseUrl + "/v1/billoflading-payments?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillOfLadingPayments(_response);
        });
    }

    protected processGetBillOfLadingPayments(response: AxiosResponse): Promise<PaymentSummaryDtoPagedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentSummaryDtoPagedResult.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentSummaryDtoPagedResult>(<any>null);
    }

    /**
     * Processes a Bill of Lading payment via 3d Secure.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The request.
     * @return Success
     */
    threeDSecure(authorization: string, body: CompleteThreeDSecureBolPaymentRequest | undefined , cancelToken?: CancelToken | undefined): Promise<BillOfLadingPaymentResponse> {
        let url_ = this.baseUrl + "/v1/billoflading-payments/threeDSecure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThreeDSecure(_response);
        });
    }

    protected processThreeDSecure(response: AxiosResponse): Promise<BillOfLadingPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillOfLadingPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = BillOfLadingPaymentResponse.fromJS(resultData201);
            return result201;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillOfLadingPaymentResponse>(<any>null);
    }

    /**
     * Gets the Bill of Lading payment by Payment Reference Number.
     * @param paymentReferenceNumber The payment reference number.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getBillOfLadingPayment(paymentReferenceNumber: string | null, authorization: string , cancelToken?: CancelToken | undefined): Promise<GetBillOfLadingPaymentResponse> {
        let url_ = this.baseUrl + "/v1/billoflading-payments/{paymentReferenceNumber}";
        if (paymentReferenceNumber === undefined || paymentReferenceNumber === null)
            throw new Error("The parameter 'paymentReferenceNumber' must be defined.");
        url_ = url_.replace("{paymentReferenceNumber}", encodeURIComponent("" + paymentReferenceNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillOfLadingPayment(_response);
        });
    }

    protected processGetBillOfLadingPayment(response: AxiosResponse): Promise<GetBillOfLadingPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBillOfLadingPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBillOfLadingPaymentResponse>(<any>null);
    }

    /**
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) 
     * @return Success
     */
    completeBillPayment(authorization: string, body: CompleteThreeDSecurePaymentRequest | undefined , cancelToken?: CancelToken | undefined): Promise<BillPaymentResponse> {
        let url_ = this.baseUrl + "/v1/billoflading-payments/CompleteBillPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteBillPayment(_response);
        });
    }

    protected processCompleteBillPayment(response: AxiosResponse): Promise<BillPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = BillPaymentResponse.fromJS(resultData201);
            return result201;
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status === 502) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillPaymentResponse>(<any>null);
    }

    /**
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) 
     * @return Success
     */
    beginBillPayment(authorization: string, body: BeginBillPaymentRequest | undefined , cancelToken?: CancelToken | undefined): Promise<BeginBillPaymentResponse> {
        let url_ = this.baseUrl + "/v1/billoflading-payments/beginBillPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginBillPayment(_response);
        });
    }

    protected processBeginBillPayment(response: AxiosResponse): Promise<BeginBillPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginBillPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginBillPaymentResponse>(<any>null);
    }

    /**
     * Registers a credit card.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The credit card details
     * @return Success
     */
    beginRegisterCreditCard(authorization: string, body: BeginRegisterCreditCardRequest | undefined , cancelToken?: CancelToken | undefined): Promise<BeginRegisterCreditCardResponse> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBeginRegisterCreditCard(_response);
        });
    }

    protected processBeginRegisterCreditCard(response: AxiosResponse): Promise<BeginRegisterCreditCardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BeginRegisterCreditCardResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BeginRegisterCreditCardResponse>(<any>null);
    }

    /**
     * Gets the credit card registrations by user ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getCreditCardRegistrations(userId: string, authorization: string , cancelToken?: CancelToken | undefined): Promise<CreditCardRegistrationDto[]> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCreditCardRegistrations(_response);
        });
    }

    protected processGetCreditCardRegistrations(response: AxiosResponse): Promise<CreditCardRegistrationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditCardRegistrationDto.fromJS(item));
            }
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreditCardRegistrationDto[]>(<any>null);
    }

    /**
     * Gets the credit card registration by ID.
     * @param id The registration id
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    getSingleCreditCardRegistration(id: number, authorization: string , cancelToken?: CancelToken | undefined): Promise<CreditCardRegistrationDto> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleCreditCardRegistration(_response);
        });
    }

    protected processGetSingleCreditCardRegistration(response: AxiosResponse): Promise<CreditCardRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreditCardRegistrationDto.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreditCardRegistrationDto>(<any>null);
    }

    /**
     * Gets the credit card registration by ID.
     * @param id The registration id
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    creditcardRegistrations(id: number, authorization: string , cancelToken?: CancelToken | undefined): Promise<CreditCardRegistrationDto> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreditcardRegistrations(_response);
        });
    }

    protected processCreditcardRegistrations(response: AxiosResponse): Promise<CreditCardRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreditCardRegistrationDto.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreditCardRegistrationDto>(<any>null);
    }

    /**
     * Deletes the credit card registration by ID.
     * @param id The registration ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    deleteCreditCardRegistration(id: number, authorization: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCreditCardRegistration(_response);
        });
    }

    protected processDeleteCreditCardRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Confirms the credit card registration by providing the random amount that was charged.
     * @param id The registration ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The request body containing the amount charged.
     * @return Success
     */
    confirmCreditCardRegistration(id: number, authorization: string, body: ConfirmCreditCardRegistrationRequestBody | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations/{id}/confirmation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmCreditCardRegistration(_response);
        });
    }

    protected processConfirmCreditCardRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Updates the credit card billing address.
     * @param id registration ID.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @param body (optional) The billing address.
     * @return Success
     */
    updateCreditCardBillingAddress(id: number, authorization: string, body: AddressDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/creditcard-registrations/{id}/billing-address";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCreditCardBillingAddress(_response);
        });
    }

    protected processUpdateCreditCardBillingAddress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    notifications(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/v1/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotifications(_response);
        });
    }

    protected processNotifications(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Gets the list of supported credit card types.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    creditcardTypes(authorization: string , cancelToken?: CancelToken | undefined): Promise<ReferenceValueDto[]> {
        let url_ = this.baseUrl + "/v1/reference-values/creditcard-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreditcardTypes(_response);
        });
    }

    protected processCreditcardTypes(response: AxiosResponse): Promise<ReferenceValueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferenceValueDto.fromJS(item));
            }
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferenceValueDto[]>(<any>null);
    }

    /**
     * Gets the list of supported credit card currencies.
     * @param authorization Bearer authorization token e.g. "Bearer [token]"
     * @return Success
     */
    creditcardCurrencies(authorization: string , cancelToken?: CancelToken | undefined): Promise<ReferenceValueDto[]> {
        let url_ = this.baseUrl + "/v1/reference-values/creditcard-currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreditcardCurrencies(_response);
        });
    }

    protected processCreditcardCurrencies(response: AxiosResponse): Promise<ReferenceValueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReferenceValueDto.fromJS(item));
            }
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403 !== undefined ? resultData403 : <any>null;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Server Error", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferenceValueDto[]>(<any>null);
    }

    /**
     * Web Hook that is called by the 3DS authenticating bank
    with the result of the user's 3DS authentication, that was captured during credit card payment
     * @param paRes (optional) 
     * @param mD (optional) 
     * @return Success
     */
    authentication(paRes: string | undefined, mD: string | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/v1/3dsecure/authentication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (paRes === null || paRes === undefined)
            throw new Error("The parameter 'paRes' cannot be null.");
        else
            content_.append("PaRes", paRes.toString());
        if (mD === null || mD === undefined)
            throw new Error("The parameter 'mD' cannot be null.");
        else
            content_.append("MD", mD.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthentication(_response);
        });
    }

    protected processAuthentication(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param cashierId (optional) 
     * @param merID (optional) 
     * @param acqID (optional) 
     * @param orderID (optional) 
     * @param responseCode (optional) 
     * @param reasonCode (optional) 
     * @param reasonCodeDesc (optional) 
     * @param referenceNo (optional) 
     * @param paddedCardNo (optional) 
     * @param authCode (optional) 
     * @param cVV2Result (optional) 
     * @param shipToFirstName (optional) 
     * @param shipToLastName (optional) 
     * @param shipToAddress1 (optional) 
     * @param shipToAddress2 (optional) 
     * @param shipToCity (optional) 
     * @param shipToState (optional) 
     * @param shipToCountry (optional) 
     * @param shipToTelephone (optional) 
     * @param shipToEMail (optional) 
     * @param billToFirstName (optional) 
     * @param billToLastName (optional) 
     * @param billToAddress1 (optional) 
     * @param billToAddress2 (optional) 
     * @param billToCity (optional) 
     * @param billToState (optional) 
     * @param billToCountry (optional) 
     * @param billToTelephone (optional) 
     * @param billToEMail (optional) 
     * @param originalResponseCode (optional) 
     * @param signature (optional) 
     * @param signatureMethod (optional) 
     * @param tokenizedPAN (optional) 
     * @return Success
     */
    verifyPayment(cashierId: string | null | undefined, merID: string | null | undefined, acqID: string | null | undefined, orderID: string | null | undefined, responseCode: string | null | undefined, reasonCode: string | null | undefined, reasonCodeDesc: string | null | undefined, referenceNo: string | null | undefined, paddedCardNo: string | null | undefined, authCode: string | null | undefined, cVV2Result: string | null | undefined, shipToFirstName: string | null | undefined, shipToLastName: string | null | undefined, shipToAddress1: string | null | undefined, shipToAddress2: string | null | undefined, shipToCity: string | null | undefined, shipToState: string | null | undefined, shipToCountry: string | null | undefined, shipToTelephone: string | null | undefined, shipToEMail: string | null | undefined, billToFirstName: string | null | undefined, billToLastName: string | null | undefined, billToAddress1: string | null | undefined, billToAddress2: string | null | undefined, billToCity: string | null | undefined, billToState: string | null | undefined, billToCountry: string | null | undefined, billToTelephone: string | null | undefined, billToEMail: string | null | undefined, originalResponseCode: string | null | undefined, signature: string | null | undefined, signatureMethod: string | null | undefined, tokenizedPAN: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<VerifyFirstAtlanticPaymentResponse> {
        let url_ = this.baseUrl + "/v1/3dsecure/verify-payment?";
        if (cashierId !== undefined && cashierId !== null)
            url_ += "CashierId=" + encodeURIComponent("" + cashierId) + "&";
        if (merID !== undefined && merID !== null)
            url_ += "MerID=" + encodeURIComponent("" + merID) + "&";
        if (acqID !== undefined && acqID !== null)
            url_ += "AcqID=" + encodeURIComponent("" + acqID) + "&";
        if (orderID !== undefined && orderID !== null)
            url_ += "OrderID=" + encodeURIComponent("" + orderID) + "&";
        if (responseCode !== undefined && responseCode !== null)
            url_ += "ResponseCode=" + encodeURIComponent("" + responseCode) + "&";
        if (reasonCode !== undefined && reasonCode !== null)
            url_ += "ReasonCode=" + encodeURIComponent("" + reasonCode) + "&";
        if (reasonCodeDesc !== undefined && reasonCodeDesc !== null)
            url_ += "ReasonCodeDesc=" + encodeURIComponent("" + reasonCodeDesc) + "&";
        if (referenceNo !== undefined && referenceNo !== null)
            url_ += "ReferenceNo=" + encodeURIComponent("" + referenceNo) + "&";
        if (paddedCardNo !== undefined && paddedCardNo !== null)
            url_ += "PaddedCardNo=" + encodeURIComponent("" + paddedCardNo) + "&";
        if (authCode !== undefined && authCode !== null)
            url_ += "AuthCode=" + encodeURIComponent("" + authCode) + "&";
        if (cVV2Result !== undefined && cVV2Result !== null)
            url_ += "CVV2Result=" + encodeURIComponent("" + cVV2Result) + "&";
        if (shipToFirstName !== undefined && shipToFirstName !== null)
            url_ += "ShipToFirstName=" + encodeURIComponent("" + shipToFirstName) + "&";
        if (shipToLastName !== undefined && shipToLastName !== null)
            url_ += "ShipToLastName=" + encodeURIComponent("" + shipToLastName) + "&";
        if (shipToAddress1 !== undefined && shipToAddress1 !== null)
            url_ += "ShipToAddress1=" + encodeURIComponent("" + shipToAddress1) + "&";
        if (shipToAddress2 !== undefined && shipToAddress2 !== null)
            url_ += "ShipToAddress2=" + encodeURIComponent("" + shipToAddress2) + "&";
        if (shipToCity !== undefined && shipToCity !== null)
            url_ += "ShipToCity=" + encodeURIComponent("" + shipToCity) + "&";
        if (shipToState !== undefined && shipToState !== null)
            url_ += "ShipToState=" + encodeURIComponent("" + shipToState) + "&";
        if (shipToCountry !== undefined && shipToCountry !== null)
            url_ += "ShipToCountry=" + encodeURIComponent("" + shipToCountry) + "&";
        if (shipToTelephone !== undefined && shipToTelephone !== null)
            url_ += "ShipToTelephone=" + encodeURIComponent("" + shipToTelephone) + "&";
        if (shipToEMail !== undefined && shipToEMail !== null)
            url_ += "ShipToEMail=" + encodeURIComponent("" + shipToEMail) + "&";
        if (billToFirstName !== undefined && billToFirstName !== null)
            url_ += "BillToFirstName=" + encodeURIComponent("" + billToFirstName) + "&";
        if (billToLastName !== undefined && billToLastName !== null)
            url_ += "BillToLastName=" + encodeURIComponent("" + billToLastName) + "&";
        if (billToAddress1 !== undefined && billToAddress1 !== null)
            url_ += "BillToAddress1=" + encodeURIComponent("" + billToAddress1) + "&";
        if (billToAddress2 !== undefined && billToAddress2 !== null)
            url_ += "BillToAddress2=" + encodeURIComponent("" + billToAddress2) + "&";
        if (billToCity !== undefined && billToCity !== null)
            url_ += "BillToCity=" + encodeURIComponent("" + billToCity) + "&";
        if (billToState !== undefined && billToState !== null)
            url_ += "BillToState=" + encodeURIComponent("" + billToState) + "&";
        if (billToCountry !== undefined && billToCountry !== null)
            url_ += "BillToCountry=" + encodeURIComponent("" + billToCountry) + "&";
        if (billToTelephone !== undefined && billToTelephone !== null)
            url_ += "BillToTelephone=" + encodeURIComponent("" + billToTelephone) + "&";
        if (billToEMail !== undefined && billToEMail !== null)
            url_ += "BillToEMail=" + encodeURIComponent("" + billToEMail) + "&";
        if (originalResponseCode !== undefined && originalResponseCode !== null)
            url_ += "OriginalResponseCode=" + encodeURIComponent("" + originalResponseCode) + "&";
        if (signature !== undefined && signature !== null)
            url_ += "Signature=" + encodeURIComponent("" + signature) + "&";
        if (signatureMethod !== undefined && signatureMethod !== null)
            url_ += "SignatureMethod=" + encodeURIComponent("" + signatureMethod) + "&";
        if (tokenizedPAN !== undefined && tokenizedPAN !== null)
            url_ += "TokenizedPAN=" + encodeURIComponent("" + tokenizedPAN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyPayment(_response);
        });
    }

    protected processVerifyPayment(response: AxiosResponse): Promise<VerifyFirstAtlanticPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyFirstAtlanticPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyFirstAtlanticPaymentResponse>(<any>null);
    }

    /**
     * @param merID (optional) 
     * @param acqID (optional) 
     * @param orderID (optional) 
     * @param responseCode (optional) 
     * @param tokenizedPAN (optional) 
     * @param reasonCode (optional) 
     * @param reasonCodeDesc (optional) 
     * @param referenceNo (optional) 
     * @param paddedCardNo (optional) 
     * @param authCode (optional) 
     * @param cVV2Result (optional) 
     * @param shipToFirstName (optional) 
     * @param shipToLastName (optional) 
     * @param shipToAddress1 (optional) 
     * @param shipToAddress2 (optional) 
     * @param shipToCity (optional) 
     * @param shipToState (optional) 
     * @param shipToCountry (optional) 
     * @param shipToTelephone (optional) 
     * @param shipToEMail (optional) 
     * @param billToFirstName (optional) 
     * @param billToLastName (optional) 
     * @param billToAddress1 (optional) 
     * @param billToAddress2 (optional) 
     * @param billToCity (optional) 
     * @param billToState (optional) 
     * @param billToCountry (optional) 
     * @param billToTelephone (optional) 
     * @param billToEMail (optional) 
     * @param originalResponseCode (optional) 
     * @param signature (optional) 
     * @param signatureMethod (optional) 
     * @return Success
     */
    verifyCard(merID: string | null | undefined, acqID: string | null | undefined, orderID: string | null | undefined, responseCode: string | null | undefined, tokenizedPAN: string | null | undefined, reasonCode: string | null | undefined, reasonCodeDesc: string | null | undefined, referenceNo: string | null | undefined, paddedCardNo: string | null | undefined, authCode: string | null | undefined, cVV2Result: string | null | undefined, shipToFirstName: string | null | undefined, shipToLastName: string | null | undefined, shipToAddress1: string | null | undefined, shipToAddress2: string | null | undefined, shipToCity: string | null | undefined, shipToState: string | null | undefined, shipToCountry: string | null | undefined, shipToTelephone: string | null | undefined, shipToEMail: string | null | undefined, billToFirstName: string | null | undefined, billToLastName: string | null | undefined, billToAddress1: string | null | undefined, billToAddress2: string | null | undefined, billToCity: string | null | undefined, billToState: string | null | undefined, billToCountry: string | null | undefined, billToTelephone: string | null | undefined, billToEMail: string | null | undefined, originalResponseCode: string | null | undefined, signature: string | null | undefined, signatureMethod: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<VerifyFirstAtlanticPaymentResponse> {
        let url_ = this.baseUrl + "/v1/3dsecure/verify-card?";
        if (merID !== undefined && merID !== null)
            url_ += "MerID=" + encodeURIComponent("" + merID) + "&";
        if (acqID !== undefined && acqID !== null)
            url_ += "AcqID=" + encodeURIComponent("" + acqID) + "&";
        if (orderID !== undefined && orderID !== null)
            url_ += "OrderID=" + encodeURIComponent("" + orderID) + "&";
        if (responseCode !== undefined && responseCode !== null)
            url_ += "ResponseCode=" + encodeURIComponent("" + responseCode) + "&";
        if (tokenizedPAN !== undefined && tokenizedPAN !== null)
            url_ += "TokenizedPAN=" + encodeURIComponent("" + tokenizedPAN) + "&";
        if (reasonCode !== undefined && reasonCode !== null)
            url_ += "ReasonCode=" + encodeURIComponent("" + reasonCode) + "&";
        if (reasonCodeDesc !== undefined && reasonCodeDesc !== null)
            url_ += "ReasonCodeDesc=" + encodeURIComponent("" + reasonCodeDesc) + "&";
        if (referenceNo !== undefined && referenceNo !== null)
            url_ += "ReferenceNo=" + encodeURIComponent("" + referenceNo) + "&";
        if (paddedCardNo !== undefined && paddedCardNo !== null)
            url_ += "PaddedCardNo=" + encodeURIComponent("" + paddedCardNo) + "&";
        if (authCode !== undefined && authCode !== null)
            url_ += "AuthCode=" + encodeURIComponent("" + authCode) + "&";
        if (cVV2Result !== undefined && cVV2Result !== null)
            url_ += "CVV2Result=" + encodeURIComponent("" + cVV2Result) + "&";
        if (shipToFirstName !== undefined && shipToFirstName !== null)
            url_ += "ShipToFirstName=" + encodeURIComponent("" + shipToFirstName) + "&";
        if (shipToLastName !== undefined && shipToLastName !== null)
            url_ += "ShipToLastName=" + encodeURIComponent("" + shipToLastName) + "&";
        if (shipToAddress1 !== undefined && shipToAddress1 !== null)
            url_ += "ShipToAddress1=" + encodeURIComponent("" + shipToAddress1) + "&";
        if (shipToAddress2 !== undefined && shipToAddress2 !== null)
            url_ += "ShipToAddress2=" + encodeURIComponent("" + shipToAddress2) + "&";
        if (shipToCity !== undefined && shipToCity !== null)
            url_ += "ShipToCity=" + encodeURIComponent("" + shipToCity) + "&";
        if (shipToState !== undefined && shipToState !== null)
            url_ += "ShipToState=" + encodeURIComponent("" + shipToState) + "&";
        if (shipToCountry !== undefined && shipToCountry !== null)
            url_ += "ShipToCountry=" + encodeURIComponent("" + shipToCountry) + "&";
        if (shipToTelephone !== undefined && shipToTelephone !== null)
            url_ += "ShipToTelephone=" + encodeURIComponent("" + shipToTelephone) + "&";
        if (shipToEMail !== undefined && shipToEMail !== null)
            url_ += "ShipToEMail=" + encodeURIComponent("" + shipToEMail) + "&";
        if (billToFirstName !== undefined && billToFirstName !== null)
            url_ += "BillToFirstName=" + encodeURIComponent("" + billToFirstName) + "&";
        if (billToLastName !== undefined && billToLastName !== null)
            url_ += "BillToLastName=" + encodeURIComponent("" + billToLastName) + "&";
        if (billToAddress1 !== undefined && billToAddress1 !== null)
            url_ += "BillToAddress1=" + encodeURIComponent("" + billToAddress1) + "&";
        if (billToAddress2 !== undefined && billToAddress2 !== null)
            url_ += "BillToAddress2=" + encodeURIComponent("" + billToAddress2) + "&";
        if (billToCity !== undefined && billToCity !== null)
            url_ += "BillToCity=" + encodeURIComponent("" + billToCity) + "&";
        if (billToState !== undefined && billToState !== null)
            url_ += "BillToState=" + encodeURIComponent("" + billToState) + "&";
        if (billToCountry !== undefined && billToCountry !== null)
            url_ += "BillToCountry=" + encodeURIComponent("" + billToCountry) + "&";
        if (billToTelephone !== undefined && billToTelephone !== null)
            url_ += "BillToTelephone=" + encodeURIComponent("" + billToTelephone) + "&";
        if (billToEMail !== undefined && billToEMail !== null)
            url_ += "BillToEMail=" + encodeURIComponent("" + billToEMail) + "&";
        if (originalResponseCode !== undefined && originalResponseCode !== null)
            url_ += "OriginalResponseCode=" + encodeURIComponent("" + originalResponseCode) + "&";
        if (signature !== undefined && signature !== null)
            url_ += "Signature=" + encodeURIComponent("" + signature) + "&";
        if (signatureMethod !== undefined && signatureMethod !== null)
            url_ += "SignatureMethod=" + encodeURIComponent("" + signatureMethod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyCard(_response);
        });
    }

    protected processVerifyCard(response: AxiosResponse): Promise<VerifyFirstAtlanticPaymentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyFirstAtlanticPaymentResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyFirstAtlanticPaymentResponse>(<any>null);
    }
}

export class BillOfLadingData implements IBillOfLadingData {
    /** Gets or sets the BOL reference numbers. */
    bolReferenceNumbers!: string[] | undefined;
    /** Gets or sets the BOL storage to date. */
    bolStorageToDate!: string;

    constructor(data?: IBillOfLadingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bolReferenceNumbers"])) {
                this.bolReferenceNumbers = [] as any;
                for (let item of _data["bolReferenceNumbers"])
                    this.bolReferenceNumbers!.push(item);
            }
            this.bolStorageToDate = _data["bolStorageToDate"];
        }
    }

    static fromJS(data: any): BillOfLadingData {
        data = typeof data === 'object' ? data : {};
        let result = new BillOfLadingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bolReferenceNumbers)) {
            data["bolReferenceNumbers"] = [];
            for (let item of this.bolReferenceNumbers)
                data["bolReferenceNumbers"].push(item);
        }
        data["bolStorageToDate"] = this.bolStorageToDate;
        return data; 
    }

    clone(): BillOfLadingData {
        const json = this.toJSON();
        let result = new BillOfLadingData();
        result.init(json);
        return result;
    }
}

export interface IBillOfLadingData {
    /** Gets or sets the BOL reference numbers. */
    bolReferenceNumbers: string[] | undefined;
    /** Gets or sets the BOL storage to date. */
    bolStorageToDate: string;
}

export class BillOfLadingChargeDto implements IBillOfLadingChargeDto {
    /** Gets or sets the name of the charge. */
    chargeName!: string | undefined;
    /** Gets or sets the charge amount. */
    amount!: number;

    constructor(data?: IBillOfLadingChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeName = _data["chargeName"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BillOfLadingChargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillOfLadingChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeName"] = this.chargeName;
        data["amount"] = this.amount;
        return data; 
    }

    clone(): BillOfLadingChargeDto {
        const json = this.toJSON();
        let result = new BillOfLadingChargeDto();
        result.init(json);
        return result;
    }
}

export interface IBillOfLadingChargeDto {
    /** Gets or sets the name of the charge. */
    chargeName: string | undefined;
    /** Gets or sets the charge amount. */
    amount: number;
}

export class BillOfLadingDto implements IBillOfLadingDto {
    /** Gets or sets the BOL number. */
    bolNumber!: string | undefined;
    bolData!: BillOfLadingData;
    /** Gets or sets the BOL charges. */
    charges!: BillOfLadingChargeDto[] | undefined;

    constructor(data?: IBillOfLadingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.bolData = data.bolData && !(<any>data.bolData).toJSON ? new BillOfLadingData(data.bolData) : <BillOfLadingData>this.bolData; 
            if (data.charges) {
                this.charges = [];
                for (let i = 0; i < data.charges.length; i++) {
                    let item = data.charges[i];
                    this.charges[i] = item && !(<any>item).toJSON ? new BillOfLadingChargeDto(item) : <BillOfLadingChargeDto>item;
                }
            }
        }
        if (!data) {
            this.bolData = new BillOfLadingData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bolNumber = _data["bolNumber"];
            this.bolData = _data["bolData"] ? BillOfLadingData.fromJS(_data["bolData"]) : new BillOfLadingData();
            if (Array.isArray(_data["charges"])) {
                this.charges = [] as any;
                for (let item of _data["charges"])
                    this.charges!.push(BillOfLadingChargeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillOfLadingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillOfLadingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bolNumber"] = this.bolNumber;
        data["bolData"] = this.bolData ? this.bolData.toJSON() : <any>undefined;
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BillOfLadingDto {
        const json = this.toJSON();
        let result = new BillOfLadingDto();
        result.init(json);
        return result;
    }
}

export interface IBillOfLadingDto {
    /** Gets or sets the BOL number. */
    bolNumber: string | undefined;
    bolData: IBillOfLadingData;
    /** Gets or sets the BOL charges. */
    charges: IBillOfLadingChargeDto[] | undefined;
}

export class PaymentMethodDto implements IPaymentMethodDto {

    protected _discriminator: string;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PaymentMethodDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "CreditCardPaymentMethodDto") {
            let result = new CreditCardPaymentMethodDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PayPalPaymentMethodDto") {
            let result = new PayPalPaymentMethodDto();
            result.init(data);
            return result;
        }
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        return data; 
    }

    clone(): PaymentMethodDto {
        const json = this.toJSON();
        let result = new PaymentMethodDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodDto {
}

/** Request to execute a Bill of Lading Payment */
export class ExecuteBillOfLadingPaymentRequest implements IExecuteBillOfLadingPaymentRequest {
    /** Gets or sets the list bill of lading charges. */
    billOfLadings?: BillOfLadingDto[] | undefined;
    /** Gets or sets the payment total. */
    total?: number;
    /** Gets or sets the payment total in Jamaican dollars. */
    totalInJmd?: number | undefined;
    paymentMethod!: PaymentMethodDto;
    /** Gets or sets the payment currency code. */
    currencyCode?: string | undefined;
    /** Gets or sets the JMD exchange rate for the payment currency. */
    jmdExchangeRate?: number;
    /** Gets or sets the user identifier. */
    userId!: string | undefined;
    /** Gets or sets the user's email address. */
    userEmailAddress!: string | undefined;
    /** Gets or sets the user's mobile phone. */
    userMobilePhone!: string | undefined;
    /** Gets or sets the browser user agent. */
    browserUserAgent?: string | undefined;

    constructor(data?: IExecuteBillOfLadingPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.billOfLadings) {
                this.billOfLadings = [];
                for (let i = 0; i < data.billOfLadings.length; i++) {
                    let item = data.billOfLadings[i];
                    this.billOfLadings[i] = item && !(<any>item).toJSON ? new BillOfLadingDto(item) : <BillOfLadingDto>item;
                }
            }
        }
        if (!data) {
            this.paymentMethod = new PaymentMethodDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["billOfLadings"])) {
                this.billOfLadings = [] as any;
                for (let item of _data["billOfLadings"])
                    this.billOfLadings!.push(BillOfLadingDto.fromJS(item));
            }
            this.total = _data["total"];
            this.totalInJmd = _data["totalInJmd"];
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodDto.fromJS(_data["paymentMethod"]) : new PaymentMethodDto();
            this.currencyCode = _data["currencyCode"];
            this.jmdExchangeRate = _data["jmdExchangeRate"];
            this.userId = _data["userId"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userMobilePhone = _data["userMobilePhone"];
            this.browserUserAgent = _data["browserUserAgent"];
        }
    }

    static fromJS(data: any): ExecuteBillOfLadingPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteBillOfLadingPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.billOfLadings)) {
            data["billOfLadings"] = [];
            for (let item of this.billOfLadings)
                data["billOfLadings"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["totalInJmd"] = this.totalInJmd;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["currencyCode"] = this.currencyCode;
        data["jmdExchangeRate"] = this.jmdExchangeRate;
        data["userId"] = this.userId;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userMobilePhone"] = this.userMobilePhone;
        data["browserUserAgent"] = this.browserUserAgent;
        return data; 
    }

    clone(): ExecuteBillOfLadingPaymentRequest {
        const json = this.toJSON();
        let result = new ExecuteBillOfLadingPaymentRequest();
        result.init(json);
        return result;
    }
}

/** Request to execute a Bill of Lading Payment */
export interface IExecuteBillOfLadingPaymentRequest {
    /** Gets or sets the list bill of lading charges. */
    billOfLadings?: IBillOfLadingDto[] | undefined;
    /** Gets or sets the payment total. */
    total?: number;
    /** Gets or sets the payment total in Jamaican dollars. */
    totalInJmd?: number | undefined;
    paymentMethod: PaymentMethodDto;
    /** Gets or sets the payment currency code. */
    currencyCode?: string | undefined;
    /** Gets or sets the JMD exchange rate for the payment currency. */
    jmdExchangeRate?: number;
    /** Gets or sets the user identifier. */
    userId: string | undefined;
    /** Gets or sets the user's email address. */
    userEmailAddress: string | undefined;
    /** Gets or sets the user's mobile phone. */
    userMobilePhone: string | undefined;
    /** Gets or sets the browser user agent. */
    browserUserAgent?: string | undefined;
}

export class BolCharge implements IBolCharge {
    /** Gets or sets the type of the charge. */
    chargeType?: string | undefined;
    /** Gets or sets the charge amount. */
    chargeAmount?: number | undefined;
    /** Gets the charge currency. */
    readonly chargeCurrency?: string | undefined;
    quantity?: number;

    constructor(data?: IBolCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeType = _data["chargeType"];
            this.chargeAmount = _data["chargeAmount"];
            (<any>this).chargeCurrency = _data["chargeCurrency"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): BolCharge {
        data = typeof data === 'object' ? data : {};
        let result = new BolCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeType"] = this.chargeType;
        data["chargeAmount"] = this.chargeAmount;
        data["chargeCurrency"] = this.chargeCurrency;
        data["quantity"] = this.quantity;
        return data; 
    }

    clone(): BolCharge {
        const json = this.toJSON();
        let result = new BolCharge();
        result.init(json);
        return result;
    }
}

export interface IBolCharge {
    /** Gets or sets the type of the charge. */
    chargeType?: string | undefined;
    /** Gets or sets the charge amount. */
    chargeAmount?: number | undefined;
    /** Gets the charge currency. */
    chargeCurrency?: string | undefined;
    quantity?: number;
}

export class BolData implements IBolData {
    handling?: number;
    /** Gets or sets the BOL reference. */
    bolReference?: string | undefined;
    /** Gets or sets the BOL number. */
    bolNumber?: string | undefined;
    /** Gets or sets the item number. */
    itemNumber?: string | undefined;
    /** Gets or sets the consignee. */
    consignee?: string | undefined;
    /** Gets or sets the vessel. */
    vessel?: string | undefined;
    /** Gets or sets the voyage number. */
    voyageNumber?: string | undefined;
    /** Gets or sets the arrival date. */
    arrivalDate?: string | undefined;
    /** Gets or sets the name of the line. */
    lineName?: string | undefined;
    /** Gets or sets the order reference. */
    orderReference?: string | undefined;
    /** Gets or sets the equipment. */
    equipment?: string | undefined;
    /** Gets or sets the location. */
    location?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the berth. */
    berth?: string | undefined;
    /** Gets or sets the storage due date. */
    storageDueDate?: string | undefined;
    /** Gets or sets the charges. */
    charges?: BolCharge[] | undefined;

    constructor(data?: IBolData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.charges) {
                this.charges = [];
                for (let i = 0; i < data.charges.length; i++) {
                    let item = data.charges[i];
                    this.charges[i] = item && !(<any>item).toJSON ? new BolCharge(item) : <BolCharge>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.handling = _data["handling"];
            this.bolReference = _data["bolReference"];
            this.bolNumber = _data["bolNumber"];
            this.itemNumber = _data["itemNumber"];
            this.consignee = _data["consignee"];
            this.vessel = _data["vessel"];
            this.voyageNumber = _data["voyageNumber"];
            this.arrivalDate = _data["arrivalDate"];
            this.lineName = _data["lineName"];
            this.orderReference = _data["orderReference"];
            this.equipment = _data["equipment"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.berth = _data["berth"];
            this.storageDueDate = _data["storageDueDate"];
            if (Array.isArray(_data["charges"])) {
                this.charges = [] as any;
                for (let item of _data["charges"])
                    this.charges!.push(BolCharge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BolData {
        data = typeof data === 'object' ? data : {};
        let result = new BolData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handling"] = this.handling;
        data["bolReference"] = this.bolReference;
        data["bolNumber"] = this.bolNumber;
        data["itemNumber"] = this.itemNumber;
        data["consignee"] = this.consignee;
        data["vessel"] = this.vessel;
        data["voyageNumber"] = this.voyageNumber;
        data["arrivalDate"] = this.arrivalDate;
        data["lineName"] = this.lineName;
        data["orderReference"] = this.orderReference;
        data["equipment"] = this.equipment;
        data["location"] = this.location;
        data["description"] = this.description;
        data["berth"] = this.berth;
        data["storageDueDate"] = this.storageDueDate;
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BolData {
        const json = this.toJSON();
        let result = new BolData();
        result.init(json);
        return result;
    }
}

export interface IBolData {
    handling?: number;
    /** Gets or sets the BOL reference. */
    bolReference?: string | undefined;
    /** Gets or sets the BOL number. */
    bolNumber?: string | undefined;
    /** Gets or sets the item number. */
    itemNumber?: string | undefined;
    /** Gets or sets the consignee. */
    consignee?: string | undefined;
    /** Gets or sets the vessel. */
    vessel?: string | undefined;
    /** Gets or sets the voyage number. */
    voyageNumber?: string | undefined;
    /** Gets or sets the arrival date. */
    arrivalDate?: string | undefined;
    /** Gets or sets the name of the line. */
    lineName?: string | undefined;
    /** Gets or sets the order reference. */
    orderReference?: string | undefined;
    /** Gets or sets the equipment. */
    equipment?: string | undefined;
    /** Gets or sets the location. */
    location?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the berth. */
    berth?: string | undefined;
    /** Gets or sets the storage due date. */
    storageDueDate?: string | undefined;
    /** Gets or sets the charges. */
    charges?: IBolCharge[] | undefined;
}

export class BillingAddressDto implements IBillingAddressDto {
    /** Gets or sets the name of the country. */
    countryName?: string | undefined;
    addressLine1!: string | undefined;
    addressLine2?: string | undefined;
    city!: string | undefined;
    /** Gets or sets the 2-character state code. Required if country specified is USA or Canada. Must be null otherwise. */
    stateCode?: string | undefined;
    /** Gets or sets the province. Required for all countries except USA and Canada. Must be null otherwise */
    province?: string | undefined;
    /** Gets or sets the zip or postal code. Required for USA and Canada */
    zipOrPostalCode?: string | undefined;
    /** Gets or sets the 2-character country code. */
    countryCode!: string | undefined;
    telephone!: string | undefined;
    firstName!: string | undefined;
    middleName?: string | undefined;
    lastName!: string | undefined;
    readonly fullName?: string | undefined;

    constructor(data?: IBillingAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.stateCode = _data["stateCode"];
            this.province = _data["province"];
            this.zipOrPostalCode = _data["zipOrPostalCode"];
            this.countryCode = _data["countryCode"];
            this.telephone = _data["telephone"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): BillingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["stateCode"] = this.stateCode;
        data["province"] = this.province;
        data["zipOrPostalCode"] = this.zipOrPostalCode;
        data["countryCode"] = this.countryCode;
        data["telephone"] = this.telephone;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data; 
    }

    clone(): BillingAddressDto {
        const json = this.toJSON();
        let result = new BillingAddressDto();
        result.init(json);
        return result;
    }
}

export interface IBillingAddressDto {
    /** Gets or sets the name of the country. */
    countryName?: string | undefined;
    addressLine1: string | undefined;
    addressLine2?: string | undefined;
    city: string | undefined;
    /** Gets or sets the 2-character state code. Required if country specified is USA or Canada. Must be null otherwise. */
    stateCode?: string | undefined;
    /** Gets or sets the province. Required for all countries except USA and Canada. Must be null otherwise */
    province?: string | undefined;
    /** Gets or sets the zip or postal code. Required for USA and Canada */
    zipOrPostalCode?: string | undefined;
    /** Gets or sets the 2-character country code. */
    countryCode: string | undefined;
    telephone: string | undefined;
    firstName: string | undefined;
    middleName?: string | undefined;
    lastName: string | undefined;
    fullName?: string | undefined;
}

export class BillOfLadingReceiptDto implements IBillOfLadingReceiptDto {
    /** Gets or sets the calling platform */
    cashierId?: string | undefined;
    /** Gets or sets the receipt number. */
    receiptNumber?: string | undefined;
    /** Gets or sets the total amount of the bill. */
    totalAmount?: number | undefined;
    /** Gets or sets the total amount paid. */
    totalAmountPaid?: number;
    /** Gets or sets the payment currency code. */
    paymentCurrency?: string | undefined;
    /** Gets or sets the receipt date. */
    receiptDate?: string | undefined;
    /** Gets or sets the list of errors. */
    errors?: string[] | undefined;
    /** Gets or sets the BOL data. */
    data?: BolData[] | undefined;
    /** Gets or sets the payment method i.e. 'Credit Card' or 'PayPal' */
    paymentMethod?: string | undefined;
    /** Gets or sets the currency of total amount. */
    totalAmountCurrency?: string | undefined;
    /** Gets or sets the type of the credit card. */
    creditCardType?: string | undefined;
    /** Gets or sets last digits of the credit card number. */
    creditCardNumberLastDigits?: string | undefined;
    billingAddress?: BillingAddressDto;
    /** Gets or sets the credit card payment authorization code. */
    authorizationCode?: string | undefined;
    /** Gets or sets the payment date. */
    paymentDate?: string;

    constructor(data?: IBillOfLadingReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.data) {
                this.data = [];
                for (let i = 0; i < data.data.length; i++) {
                    let item = data.data[i];
                    this.data[i] = item && !(<any>item).toJSON ? new BolData(item) : <BolData>item;
                }
            }
            this.billingAddress = data.billingAddress && !(<any>data.billingAddress).toJSON ? new BillingAddressDto(data.billingAddress) : <BillingAddressDto>this.billingAddress; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashierId = _data["cashierId"];
            this.receiptNumber = _data["receiptNumber"];
            this.totalAmount = _data["totalAmount"];
            this.totalAmountPaid = _data["totalAmountPaid"];
            this.paymentCurrency = _data["paymentCurrency"];
            this.receiptDate = _data["receiptDate"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BolData.fromJS(item));
            }
            this.paymentMethod = _data["paymentMethod"];
            this.totalAmountCurrency = _data["totalAmountCurrency"];
            this.creditCardType = _data["creditCardType"];
            this.creditCardNumberLastDigits = _data["creditCardNumberLastDigits"];
            this.billingAddress = _data["billingAddress"] ? BillingAddressDto.fromJS(_data["billingAddress"]) : <any>undefined;
            this.authorizationCode = _data["authorizationCode"];
            this.paymentDate = _data["paymentDate"];
        }
    }

    static fromJS(data: any): BillOfLadingReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillOfLadingReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierId"] = this.cashierId;
        data["receiptNumber"] = this.receiptNumber;
        data["totalAmount"] = this.totalAmount;
        data["totalAmountPaid"] = this.totalAmountPaid;
        data["paymentCurrency"] = this.paymentCurrency;
        data["receiptDate"] = this.receiptDate;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["paymentMethod"] = this.paymentMethod;
        data["totalAmountCurrency"] = this.totalAmountCurrency;
        data["creditCardType"] = this.creditCardType;
        data["creditCardNumberLastDigits"] = this.creditCardNumberLastDigits;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["authorizationCode"] = this.authorizationCode;
        data["paymentDate"] = this.paymentDate;
        return data; 
    }

    clone(): BillOfLadingReceiptDto {
        const json = this.toJSON();
        let result = new BillOfLadingReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IBillOfLadingReceiptDto {
    /** Gets or sets the calling platform */
    cashierId?: string | undefined;
    /** Gets or sets the receipt number. */
    receiptNumber?: string | undefined;
    /** Gets or sets the total amount of the bill. */
    totalAmount?: number | undefined;
    /** Gets or sets the total amount paid. */
    totalAmountPaid?: number;
    /** Gets or sets the payment currency code. */
    paymentCurrency?: string | undefined;
    /** Gets or sets the receipt date. */
    receiptDate?: string | undefined;
    /** Gets or sets the list of errors. */
    errors?: string[] | undefined;
    /** Gets or sets the BOL data. */
    data?: IBolData[] | undefined;
    /** Gets or sets the payment method i.e. 'Credit Card' or 'PayPal' */
    paymentMethod?: string | undefined;
    /** Gets or sets the currency of total amount. */
    totalAmountCurrency?: string | undefined;
    /** Gets or sets the type of the credit card. */
    creditCardType?: string | undefined;
    /** Gets or sets last digits of the credit card number. */
    creditCardNumberLastDigits?: string | undefined;
    billingAddress?: IBillingAddressDto;
    /** Gets or sets the credit card payment authorization code. */
    authorizationCode?: string | undefined;
    /** Gets or sets the payment date. */
    paymentDate?: string;
}

/** Represents the 3D Secure Form that allows the user to enter validate their 3D secure credentials */
export class ThreeDSecureAcsFormParams implements IThreeDSecureAcsFormParams {
    /** Gets or sets the ACS URL. */
    acsUrl?: string | undefined;
    /** Gets or sets the PAR payload. */
    parPayload?: string | undefined;
    /** Gets or sets the merchant reference number. */
    merchantReferenceNumber?: string | undefined;
    /** Gets or sets the term URL. */
    termUrl?: string | undefined;

    constructor(data?: IThreeDSecureAcsFormParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acsUrl = _data["acsUrl"];
            this.parPayload = _data["parPayload"];
            this.merchantReferenceNumber = _data["merchantReferenceNumber"];
            this.termUrl = _data["termUrl"];
        }
    }

    static fromJS(data: any): ThreeDSecureAcsFormParams {
        data = typeof data === 'object' ? data : {};
        let result = new ThreeDSecureAcsFormParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acsUrl"] = this.acsUrl;
        data["parPayload"] = this.parPayload;
        data["merchantReferenceNumber"] = this.merchantReferenceNumber;
        data["termUrl"] = this.termUrl;
        return data; 
    }

    clone(): ThreeDSecureAcsFormParams {
        const json = this.toJSON();
        let result = new ThreeDSecureAcsFormParams();
        result.init(json);
        return result;
    }
}

/** Represents the 3D Secure Form that allows the user to enter validate their 3D secure credentials */
export interface IThreeDSecureAcsFormParams {
    /** Gets or sets the ACS URL. */
    acsUrl?: string | undefined;
    /** Gets or sets the PAR payload. */
    parPayload?: string | undefined;
    /** Gets or sets the merchant reference number. */
    merchantReferenceNumber?: string | undefined;
    /** Gets or sets the term URL. */
    termUrl?: string | undefined;
}

/** BillOfLadingPaymentResponse class */
export class BillOfLadingPaymentResponse implements IBillOfLadingPaymentResponse {
    receipt?: BillOfLadingReceiptDto;
    /** Gets or sets the payment refence number. */
    paymentRefenceNumber?: string | undefined;
    /** Gets or sets a value indicating whether the payment was successful. */
    isPaymentSuccessful?: boolean;
    threeDSecureAcsFormParams?: ThreeDSecureAcsFormParams;
    /** Gets or sets the payment error code if there was a payment error. */
    errorCode?: string | undefined;

    constructor(data?: IBillOfLadingPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.receipt = data.receipt && !(<any>data.receipt).toJSON ? new BillOfLadingReceiptDto(data.receipt) : <BillOfLadingReceiptDto>this.receipt; 
            this.threeDSecureAcsFormParams = data.threeDSecureAcsFormParams && !(<any>data.threeDSecureAcsFormParams).toJSON ? new ThreeDSecureAcsFormParams(data.threeDSecureAcsFormParams) : <ThreeDSecureAcsFormParams>this.threeDSecureAcsFormParams; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receipt = _data["receipt"] ? BillOfLadingReceiptDto.fromJS(_data["receipt"]) : <any>undefined;
            this.paymentRefenceNumber = _data["paymentRefenceNumber"];
            this.isPaymentSuccessful = _data["isPaymentSuccessful"];
            this.threeDSecureAcsFormParams = _data["threeDSecureAcsFormParams"] ? ThreeDSecureAcsFormParams.fromJS(_data["threeDSecureAcsFormParams"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): BillOfLadingPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillOfLadingPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receipt"] = this.receipt ? this.receipt.toJSON() : <any>undefined;
        data["paymentRefenceNumber"] = this.paymentRefenceNumber;
        data["isPaymentSuccessful"] = this.isPaymentSuccessful;
        data["threeDSecureAcsFormParams"] = this.threeDSecureAcsFormParams ? this.threeDSecureAcsFormParams.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data; 
    }

    clone(): BillOfLadingPaymentResponse {
        const json = this.toJSON();
        let result = new BillOfLadingPaymentResponse();
        result.init(json);
        return result;
    }
}

/** BillOfLadingPaymentResponse class */
export interface IBillOfLadingPaymentResponse {
    receipt?: IBillOfLadingReceiptDto;
    /** Gets or sets the payment refence number. */
    paymentRefenceNumber?: string | undefined;
    /** Gets or sets a value indicating whether the payment was successful. */
    isPaymentSuccessful?: boolean;
    threeDSecureAcsFormParams?: IThreeDSecureAcsFormParams;
    /** Gets or sets the payment error code if there was a payment error. */
    errorCode?: string | undefined;
}

export class PaymentSummaryDto implements IPaymentSummaryDto {
    /** Gets or sets the payment identifier. */
    paymentId?: number;
    /** Gets or sets the user identifier. */
    userId?: string | undefined;
    /** Gets or sets the payment reference number. */
    paymentReferenceNumber?: string | undefined;
    /** Gets or sets the payment method. Either "CreditCard" or "PayPal" */
    paymentMethod?: string | undefined;
    /** Gets or sets the payment date. */
    paymentDate?: string;
    isSucessful?: boolean;
    /** Gets or sets the error code. */
    errorCode?: string | undefined;
    /** Gets or sets the total payment amount. */
    total?: number;
    /** Gets or sets the currency code of payment. */
    currencyCode?: string | undefined;
    /** Gets or sets the payment total in Jamaican Dollars. */
    totalInJmd?: number;
    /** Gets or sets the Jamaican dollar exchange rate of the payment currency. */
    jmdExchangeRate?: number;
    /** Gets or sets the last four digits of the credit card number. */
    cardNumberLastFourDigits?: string | undefined;
    /** Gets or sets the type of the credit card: "VISA", "MASTERCARD" or "KEYCARD" */
    cardType?: string | undefined;
    /** Gets or sets the receipt number. */
    receiptNumber?: string | undefined;
    /** Gets or sets the type of the receipt, e.g. "APM" */
    receiptType?: string | undefined;
    /** Gets or sets a value indicating whether the receipt email was sent. */
    isReceiptEmailSent?: boolean;
    /** Gets or sets the receipt status code, i.e. "GENERATION_ERROR", "SEND_ERROR" or "SENT" */
    receiptStatusCode?: string | undefined;
    /** Gets or sets the receipt status detail. */
    receiptStatusDetail?: string | undefined;

    constructor(data?: IPaymentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.userId = _data["userId"];
            this.paymentReferenceNumber = _data["paymentReferenceNumber"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentDate = _data["paymentDate"];
            this.isSucessful = _data["isSucessful"];
            this.errorCode = _data["errorCode"];
            this.total = _data["total"];
            this.currencyCode = _data["currencyCode"];
            this.totalInJmd = _data["totalInJmd"];
            this.jmdExchangeRate = _data["jmdExchangeRate"];
            this.cardNumberLastFourDigits = _data["cardNumberLastFourDigits"];
            this.cardType = _data["cardType"];
            this.receiptNumber = _data["receiptNumber"];
            this.receiptType = _data["receiptType"];
            this.isReceiptEmailSent = _data["isReceiptEmailSent"];
            this.receiptStatusCode = _data["receiptStatusCode"];
            this.receiptStatusDetail = _data["receiptStatusDetail"];
        }
    }

    static fromJS(data: any): PaymentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["userId"] = this.userId;
        data["paymentReferenceNumber"] = this.paymentReferenceNumber;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentDate"] = this.paymentDate;
        data["isSucessful"] = this.isSucessful;
        data["errorCode"] = this.errorCode;
        data["total"] = this.total;
        data["currencyCode"] = this.currencyCode;
        data["totalInJmd"] = this.totalInJmd;
        data["jmdExchangeRate"] = this.jmdExchangeRate;
        data["cardNumberLastFourDigits"] = this.cardNumberLastFourDigits;
        data["cardType"] = this.cardType;
        data["receiptNumber"] = this.receiptNumber;
        data["receiptType"] = this.receiptType;
        data["isReceiptEmailSent"] = this.isReceiptEmailSent;
        data["receiptStatusCode"] = this.receiptStatusCode;
        data["receiptStatusDetail"] = this.receiptStatusDetail;
        return data; 
    }

    clone(): PaymentSummaryDto {
        const json = this.toJSON();
        let result = new PaymentSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentSummaryDto {
    /** Gets or sets the payment identifier. */
    paymentId?: number;
    /** Gets or sets the user identifier. */
    userId?: string | undefined;
    /** Gets or sets the payment reference number. */
    paymentReferenceNumber?: string | undefined;
    /** Gets or sets the payment method. Either "CreditCard" or "PayPal" */
    paymentMethod?: string | undefined;
    /** Gets or sets the payment date. */
    paymentDate?: string;
    isSucessful?: boolean;
    /** Gets or sets the error code. */
    errorCode?: string | undefined;
    /** Gets or sets the total payment amount. */
    total?: number;
    /** Gets or sets the currency code of payment. */
    currencyCode?: string | undefined;
    /** Gets or sets the payment total in Jamaican Dollars. */
    totalInJmd?: number;
    /** Gets or sets the Jamaican dollar exchange rate of the payment currency. */
    jmdExchangeRate?: number;
    /** Gets or sets the last four digits of the credit card number. */
    cardNumberLastFourDigits?: string | undefined;
    /** Gets or sets the type of the credit card: "VISA", "MASTERCARD" or "KEYCARD" */
    cardType?: string | undefined;
    /** Gets or sets the receipt number. */
    receiptNumber?: string | undefined;
    /** Gets or sets the type of the receipt, e.g. "APM" */
    receiptType?: string | undefined;
    /** Gets or sets a value indicating whether the receipt email was sent. */
    isReceiptEmailSent?: boolean;
    /** Gets or sets the receipt status code, i.e. "GENERATION_ERROR", "SEND_ERROR" or "SENT" */
    receiptStatusCode?: string | undefined;
    /** Gets or sets the receipt status detail. */
    receiptStatusDetail?: string | undefined;
}

export class PaymentSummaryDtoPagedResult implements IPaymentSummaryDtoPagedResult {
    /** Gets the zero-based page index. */
    readonly pageIndex?: number;
    /** Gets the page size of the result. */
    readonly pageSize?: number;
    /** Gets the total number of pages. */
    readonly pageCount?: number;
    /** Gets the total number of items matched by the query. */
    readonly itemCount?: number;
    /** Gets the current page data. */
    readonly page?: PaymentSummaryDto[] | undefined;

    constructor(data?: IPaymentSummaryDtoPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.page) {
                this.page = [];
                for (let i = 0; i < data.page.length; i++) {
                    let item = data.page[i];
                    this.page[i] = item && !(<any>item).toJSON ? new PaymentSummaryDto(item) : <PaymentSummaryDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).pageIndex = _data["pageIndex"];
            (<any>this).pageSize = _data["pageSize"];
            (<any>this).pageCount = _data["pageCount"];
            (<any>this).itemCount = _data["itemCount"];
            if (Array.isArray(_data["page"])) {
                (<any>this).page = [] as any;
                for (let item of _data["page"])
                    (<any>this).page!.push(PaymentSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentSummaryDtoPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentSummaryDtoPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["pageCount"] = this.pageCount;
        data["itemCount"] = this.itemCount;
        if (Array.isArray(this.page)) {
            data["page"] = [];
            for (let item of this.page)
                data["page"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PaymentSummaryDtoPagedResult {
        const json = this.toJSON();
        let result = new PaymentSummaryDtoPagedResult();
        result.init(json);
        return result;
    }
}

export interface IPaymentSummaryDtoPagedResult {
    /** Gets the zero-based page index. */
    pageIndex?: number;
    /** Gets the page size of the result. */
    pageSize?: number;
    /** Gets the total number of pages. */
    pageCount?: number;
    /** Gets the total number of items matched by the query. */
    itemCount?: number;
    /** Gets the current page data. */
    page?: IPaymentSummaryDto[] | undefined;
}

export class AddressDto implements IAddressDto {
    addressLine1!: string | undefined;
    addressLine2?: string | undefined;
    city!: string | undefined;
    /** Gets or sets the 2-character state code. Required if country specified is USA or Canada. Must be null otherwise. */
    stateCode?: string | undefined;
    /** Gets or sets the province. Required for all countries except USA and Canada. Must be null otherwise */
    province?: string | undefined;
    /** Gets or sets the zip or postal code. Required for USA and Canada */
    zipOrPostalCode?: string | undefined;
    /** Gets or sets the 2-character country code. */
    countryCode!: string | undefined;
    telephone!: string | undefined;
    firstName!: string | undefined;
    middleName?: string | undefined;
    lastName!: string | undefined;
    readonly fullName?: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.stateCode = _data["stateCode"];
            this.province = _data["province"];
            this.zipOrPostalCode = _data["zipOrPostalCode"];
            this.countryCode = _data["countryCode"];
            this.telephone = _data["telephone"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["stateCode"] = this.stateCode;
        data["province"] = this.province;
        data["zipOrPostalCode"] = this.zipOrPostalCode;
        data["countryCode"] = this.countryCode;
        data["telephone"] = this.telephone;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    addressLine1: string | undefined;
    addressLine2?: string | undefined;
    city: string | undefined;
    /** Gets or sets the 2-character state code. Required if country specified is USA or Canada. Must be null otherwise. */
    stateCode?: string | undefined;
    /** Gets or sets the province. Required for all countries except USA and Canada. Must be null otherwise */
    province?: string | undefined;
    /** Gets or sets the zip or postal code. Required for USA and Canada */
    zipOrPostalCode?: string | undefined;
    /** Gets or sets the 2-character country code. */
    countryCode: string | undefined;
    telephone: string | undefined;
    firstName: string | undefined;
    middleName?: string | undefined;
    lastName: string | undefined;
    fullName?: string | undefined;
}

export class CreditCardDetailsDto implements ICreditCardDetailsDto {
    /** Gets or sets the card type ID. Valid values are: "VISA", "MASTERCARD" and "KEYCARD" */
    cardTypeId!: string | undefined;
    /** Gets or sets the card 3-character currency code. */
    cardCurrencyCode!: string | undefined;
    /** Gets or sets the name on the credit card. */
    cardName?: string | undefined;
    cardNumber!: string | undefined;
    readonly cardNumberFirstFourDigits?: string | undefined;
    readonly cardNumberLastFourDigits?: string | undefined;
    cvv!: string | undefined;
    /** Gets or sets the 2-digit expiry month, e.g. 04 for April. */
    expiryMonth!: string | undefined;
    /** Gets or sets the 4-digit expiry year, e.g. 2020. */
    expiryYear!: string | undefined;
    readonly expiry?: string | undefined;
    readonly expiryYear2Digits?: string | undefined;
    billingAddress!: AddressDto;

    constructor(data?: ICreditCardDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.billingAddress = data.billingAddress && !(<any>data.billingAddress).toJSON ? new AddressDto(data.billingAddress) : <AddressDto>this.billingAddress; 
        }
        if (!data) {
            this.billingAddress = new AddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardTypeId = _data["cardTypeId"];
            this.cardCurrencyCode = _data["cardCurrencyCode"];
            this.cardName = _data["cardName"];
            this.cardNumber = _data["cardNumber"];
            (<any>this).cardNumberFirstFourDigits = _data["cardNumberFirstFourDigits"];
            (<any>this).cardNumberLastFourDigits = _data["cardNumberLastFourDigits"];
            this.cvv = _data["cvv"];
            this.expiryMonth = _data["expiryMonth"];
            this.expiryYear = _data["expiryYear"];
            (<any>this).expiry = _data["expiry"];
            (<any>this).expiryYear2Digits = _data["expiryYear2Digits"];
            this.billingAddress = _data["billingAddress"] ? AddressDto.fromJS(_data["billingAddress"]) : new AddressDto();
        }
    }

    static fromJS(data: any): CreditCardDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTypeId"] = this.cardTypeId;
        data["cardCurrencyCode"] = this.cardCurrencyCode;
        data["cardName"] = this.cardName;
        data["cardNumber"] = this.cardNumber;
        data["cardNumberFirstFourDigits"] = this.cardNumberFirstFourDigits;
        data["cardNumberLastFourDigits"] = this.cardNumberLastFourDigits;
        data["cvv"] = this.cvv;
        data["expiryMonth"] = this.expiryMonth;
        data["expiryYear"] = this.expiryYear;
        data["expiry"] = this.expiry;
        data["expiryYear2Digits"] = this.expiryYear2Digits;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CreditCardDetailsDto {
        const json = this.toJSON();
        let result = new CreditCardDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ICreditCardDetailsDto {
    /** Gets or sets the card type ID. Valid values are: "VISA", "MASTERCARD" and "KEYCARD" */
    cardTypeId: string | undefined;
    /** Gets or sets the card 3-character currency code. */
    cardCurrencyCode: string | undefined;
    /** Gets or sets the name on the credit card. */
    cardName?: string | undefined;
    cardNumber: string | undefined;
    cardNumberFirstFourDigits?: string | undefined;
    cardNumberLastFourDigits?: string | undefined;
    cvv: string | undefined;
    /** Gets or sets the 2-digit expiry month, e.g. 04 for April. */
    expiryMonth: string | undefined;
    /** Gets or sets the 4-digit expiry year, e.g. 2020. */
    expiryYear: string | undefined;
    expiry?: string | undefined;
    expiryYear2Digits?: string | undefined;
    billingAddress: IAddressDto;
}

export class CompleteThreeDSecureBolPaymentRequest implements ICompleteThreeDSecureBolPaymentRequest {
    paymentReferenceNumber!: string | undefined;
    userEmailAddress!: string | undefined;
    creditCardDetails!: CreditCardDetailsDto;
    userId!: string | undefined;

    constructor(data?: ICompleteThreeDSecureBolPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.creditCardDetails = data.creditCardDetails && !(<any>data.creditCardDetails).toJSON ? new CreditCardDetailsDto(data.creditCardDetails) : <CreditCardDetailsDto>this.creditCardDetails; 
        }
        if (!data) {
            this.creditCardDetails = new CreditCardDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentReferenceNumber = _data["paymentReferenceNumber"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.creditCardDetails = _data["creditCardDetails"] ? CreditCardDetailsDto.fromJS(_data["creditCardDetails"]) : new CreditCardDetailsDto();
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CompleteThreeDSecureBolPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteThreeDSecureBolPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentReferenceNumber"] = this.paymentReferenceNumber;
        data["userEmailAddress"] = this.userEmailAddress;
        data["creditCardDetails"] = this.creditCardDetails ? this.creditCardDetails.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): CompleteThreeDSecureBolPaymentRequest {
        const json = this.toJSON();
        let result = new CompleteThreeDSecureBolPaymentRequest();
        result.init(json);
        return result;
    }
}

export interface ICompleteThreeDSecureBolPaymentRequest {
    paymentReferenceNumber: string | undefined;
    userEmailAddress: string | undefined;
    creditCardDetails: ICreditCardDetailsDto;
    userId: string | undefined;
}

export class GetBillOfLadingPaymentResponse implements IGetBillOfLadingPaymentResponse {
    paymentDetails?: PaymentSummaryDto;
    billOfLadings?: BillOfLadingDto[] | undefined;

    constructor(data?: IGetBillOfLadingPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.paymentDetails = data.paymentDetails && !(<any>data.paymentDetails).toJSON ? new PaymentSummaryDto(data.paymentDetails) : <PaymentSummaryDto>this.paymentDetails; 
            if (data.billOfLadings) {
                this.billOfLadings = [];
                for (let i = 0; i < data.billOfLadings.length; i++) {
                    let item = data.billOfLadings[i];
                    this.billOfLadings[i] = item && !(<any>item).toJSON ? new BillOfLadingDto(item) : <BillOfLadingDto>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDetails = _data["paymentDetails"] ? PaymentSummaryDto.fromJS(_data["paymentDetails"]) : <any>undefined;
            if (Array.isArray(_data["billOfLadings"])) {
                this.billOfLadings = [] as any;
                for (let item of _data["billOfLadings"])
                    this.billOfLadings!.push(BillOfLadingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBillOfLadingPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillOfLadingPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDetails"] = this.paymentDetails ? this.paymentDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.billOfLadings)) {
            data["billOfLadings"] = [];
            for (let item of this.billOfLadings)
                data["billOfLadings"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetBillOfLadingPaymentResponse {
        const json = this.toJSON();
        let result = new GetBillOfLadingPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IGetBillOfLadingPaymentResponse {
    paymentDetails?: IPaymentSummaryDto;
    billOfLadings?: IBillOfLadingDto[] | undefined;
}

export class CompleteThreeDSecurePaymentRequest implements ICompleteThreeDSecurePaymentRequest {
    paymentReferenceNumber!: string | undefined;
    userEmailAddress!: string | undefined;
    creditCardDetails!: CreditCardDetailsDto;
    userId!: string | undefined;

    constructor(data?: ICompleteThreeDSecurePaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.creditCardDetails = data.creditCardDetails && !(<any>data.creditCardDetails).toJSON ? new CreditCardDetailsDto(data.creditCardDetails) : <CreditCardDetailsDto>this.creditCardDetails; 
        }
        if (!data) {
            this.creditCardDetails = new CreditCardDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentReferenceNumber = _data["paymentReferenceNumber"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.creditCardDetails = _data["creditCardDetails"] ? CreditCardDetailsDto.fromJS(_data["creditCardDetails"]) : new CreditCardDetailsDto();
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CompleteThreeDSecurePaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteThreeDSecurePaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentReferenceNumber"] = this.paymentReferenceNumber;
        data["userEmailAddress"] = this.userEmailAddress;
        data["creditCardDetails"] = this.creditCardDetails ? this.creditCardDetails.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): CompleteThreeDSecurePaymentRequest {
        const json = this.toJSON();
        let result = new CompleteThreeDSecurePaymentRequest();
        result.init(json);
        return result;
    }
}

export interface ICompleteThreeDSecurePaymentRequest {
    paymentReferenceNumber: string | undefined;
    userEmailAddress: string | undefined;
    creditCardDetails: ICreditCardDetailsDto;
    userId: string | undefined;
}

export class BillPaymentResponse implements IBillPaymentResponse {
    /** Gets or sets the payment refence number. */
    paymentRefenceNumber?: string | undefined;
    /** Gets or sets a value indicating whether the payment was successful. */
    isPaymentSuccessful?: boolean;
    threeDSecureAcsFormParams?: ThreeDSecureAcsFormParams;
    /** Gets or sets the payment error code if there was a payment error. */
    errorCode?: string | undefined;

    constructor(data?: IBillPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.threeDSecureAcsFormParams = data.threeDSecureAcsFormParams && !(<any>data.threeDSecureAcsFormParams).toJSON ? new ThreeDSecureAcsFormParams(data.threeDSecureAcsFormParams) : <ThreeDSecureAcsFormParams>this.threeDSecureAcsFormParams; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentRefenceNumber = _data["paymentRefenceNumber"];
            this.isPaymentSuccessful = _data["isPaymentSuccessful"];
            this.threeDSecureAcsFormParams = _data["threeDSecureAcsFormParams"] ? ThreeDSecureAcsFormParams.fromJS(_data["threeDSecureAcsFormParams"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): BillPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BillPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentRefenceNumber"] = this.paymentRefenceNumber;
        data["isPaymentSuccessful"] = this.isPaymentSuccessful;
        data["threeDSecureAcsFormParams"] = this.threeDSecureAcsFormParams ? this.threeDSecureAcsFormParams.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        return data; 
    }

    clone(): BillPaymentResponse {
        const json = this.toJSON();
        let result = new BillPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IBillPaymentResponse {
    /** Gets or sets the payment refence number. */
    paymentRefenceNumber?: string | undefined;
    /** Gets or sets a value indicating whether the payment was successful. */
    isPaymentSuccessful?: boolean;
    threeDSecureAcsFormParams?: IThreeDSecureAcsFormParams;
    /** Gets or sets the payment error code if there was a payment error. */
    errorCode?: string | undefined;
}

export class CreditCardPaymentMethodDto extends PaymentMethodDto implements ICreditCardPaymentMethodDto {
    cardDetails?: CreditCardDetailsDto;
    paymentCardId?: number | undefined;

    constructor(data?: ICreditCardPaymentMethodDto) {
        super(data);
        if (data) {
            this.cardDetails = data.cardDetails && !(<any>data.cardDetails).toJSON ? new CreditCardDetailsDto(data.cardDetails) : <CreditCardDetailsDto>this.cardDetails; 
        }
        this._discriminator = "CreditCardPaymentMethodDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cardDetails = _data["cardDetails"] ? CreditCardDetailsDto.fromJS(_data["cardDetails"]) : <any>undefined;
            this.paymentCardId = _data["paymentCardId"];
        }
    }

    static fromJS(data: any): CreditCardPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardDetails"] = this.cardDetails ? this.cardDetails.toJSON() : <any>undefined;
        data["paymentCardId"] = this.paymentCardId;
        super.toJSON(data);
        return data; 
    }

    clone(): CreditCardPaymentMethodDto {
        const json = this.toJSON();
        let result = new CreditCardPaymentMethodDto();
        result.init(json);
        return result;
    }
}

export interface ICreditCardPaymentMethodDto extends IPaymentMethodDto {
    cardDetails?: ICreditCardDetailsDto;
    paymentCardId?: number | undefined;
}

export class BeginBillPaymentRequest implements IBeginBillPaymentRequest {
    cashierId!: string | undefined;
    billOfLadings?: BillOfLadingDto[] | undefined;
    shippingAddress?: AddressDto;
    /** Gets or sets the payment total. */
    total?: number;
    shouldTokenize?: boolean;
    /** Gets or sets the payment total in Jamaican dollars. */
    totalInJmd?: number | undefined;
    paymentMethod!: CreditCardPaymentMethodDto;
    /** Gets or sets the payment currency code. */
    currencyCode?: string | undefined;
    /** Gets or sets the JMD exchange rate for the payment currency. */
    jmdExchangeRate?: number;
    /** Gets or sets the user identifier. */
    userId!: string | undefined;
    /** Gets or sets the user's email address. */
    userEmailAddress!: string | undefined;
    /** Gets or sets the user's mobile phone. */
    userMobilePhone!: string | undefined;
    /** Gets or sets the browser user agent. */
    browserUserAgent?: string | undefined;

    constructor(data?: IBeginBillPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.billOfLadings) {
                this.billOfLadings = [];
                for (let i = 0; i < data.billOfLadings.length; i++) {
                    let item = data.billOfLadings[i];
                    this.billOfLadings[i] = item && !(<any>item).toJSON ? new BillOfLadingDto(item) : <BillOfLadingDto>item;
                }
            }
            this.shippingAddress = data.shippingAddress && !(<any>data.shippingAddress).toJSON ? new AddressDto(data.shippingAddress) : <AddressDto>this.shippingAddress; 
        }
        if (!data) {
            this.paymentMethod = new CreditCardPaymentMethodDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashierId = _data["cashierId"];
            if (Array.isArray(_data["billOfLadings"])) {
                this.billOfLadings = [] as any;
                for (let item of _data["billOfLadings"])
                    this.billOfLadings!.push(BillOfLadingDto.fromJS(item));
            }
            this.shippingAddress = _data["shippingAddress"] ? AddressDto.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.total = _data["total"];
            this.shouldTokenize = _data["shouldTokenize"];
            this.totalInJmd = _data["totalInJmd"];
            this.paymentMethod = _data["paymentMethod"] ? CreditCardPaymentMethodDto.fromJS(_data["paymentMethod"]) : new CreditCardPaymentMethodDto();
            this.currencyCode = _data["currencyCode"];
            this.jmdExchangeRate = _data["jmdExchangeRate"];
            this.userId = _data["userId"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.userMobilePhone = _data["userMobilePhone"];
            this.browserUserAgent = _data["browserUserAgent"];
        }
    }

    static fromJS(data: any): BeginBillPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BeginBillPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashierId"] = this.cashierId;
        if (Array.isArray(this.billOfLadings)) {
            data["billOfLadings"] = [];
            for (let item of this.billOfLadings)
                data["billOfLadings"].push(item.toJSON());
        }
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["total"] = this.total;
        data["shouldTokenize"] = this.shouldTokenize;
        data["totalInJmd"] = this.totalInJmd;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["currencyCode"] = this.currencyCode;
        data["jmdExchangeRate"] = this.jmdExchangeRate;
        data["userId"] = this.userId;
        data["userEmailAddress"] = this.userEmailAddress;
        data["userMobilePhone"] = this.userMobilePhone;
        data["browserUserAgent"] = this.browserUserAgent;
        return data; 
    }

    clone(): BeginBillPaymentRequest {
        const json = this.toJSON();
        let result = new BeginBillPaymentRequest();
        result.init(json);
        return result;
    }
}

export interface IBeginBillPaymentRequest {
    cashierId: string | undefined;
    billOfLadings?: IBillOfLadingDto[] | undefined;
    shippingAddress?: IAddressDto;
    /** Gets or sets the payment total. */
    total?: number;
    shouldTokenize?: boolean;
    /** Gets or sets the payment total in Jamaican dollars. */
    totalInJmd?: number | undefined;
    paymentMethod: CreditCardPaymentMethodDto;
    /** Gets or sets the payment currency code. */
    currencyCode?: string | undefined;
    /** Gets or sets the JMD exchange rate for the payment currency. */
    jmdExchangeRate?: number;
    /** Gets or sets the user identifier. */
    userId: string | undefined;
    /** Gets or sets the user's email address. */
    userEmailAddress: string | undefined;
    /** Gets or sets the user's mobile phone. */
    userMobilePhone: string | undefined;
    /** Gets or sets the browser user agent. */
    browserUserAgent?: string | undefined;
}

export class BeginBillPaymentResponse implements IBeginBillPaymentResponse {
    errorCode?: string | undefined;
    htmlCode?: string | undefined;
    success?: boolean;
    paymentRefenceNumber?: string | undefined;
    message?: string | undefined;
    receipt?: BillOfLadingReceiptDto;

    constructor(data?: IBeginBillPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.receipt = data.receipt && !(<any>data.receipt).toJSON ? new BillOfLadingReceiptDto(data.receipt) : <BillOfLadingReceiptDto>this.receipt; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.htmlCode = _data["htmlCode"];
            this.success = _data["success"];
            this.paymentRefenceNumber = _data["paymentRefenceNumber"];
            this.message = _data["message"];
            this.receipt = _data["receipt"] ? BillOfLadingReceiptDto.fromJS(_data["receipt"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BeginBillPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeginBillPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["htmlCode"] = this.htmlCode;
        data["success"] = this.success;
        data["paymentRefenceNumber"] = this.paymentRefenceNumber;
        data["message"] = this.message;
        data["receipt"] = this.receipt ? this.receipt.toJSON() : <any>undefined;
        return data; 
    }

    clone(): BeginBillPaymentResponse {
        const json = this.toJSON();
        let result = new BeginBillPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IBeginBillPaymentResponse {
    errorCode?: string | undefined;
    htmlCode?: string | undefined;
    success?: boolean;
    paymentRefenceNumber?: string | undefined;
    message?: string | undefined;
    receipt?: IBillOfLadingReceiptDto;
}

export class BeginRegisterCreditCardRequest implements IBeginRegisterCreditCardRequest {
    userId!: string | undefined;
    userEmailAddress!: string | undefined;
    cardDetails!: CreditCardDetailsDto;
    saveTokenizeCard?: boolean | undefined;

    constructor(data?: IBeginRegisterCreditCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.cardDetails = data.cardDetails && !(<any>data.cardDetails).toJSON ? new CreditCardDetailsDto(data.cardDetails) : <CreditCardDetailsDto>this.cardDetails; 
        }
        if (!data) {
            this.cardDetails = new CreditCardDetailsDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userEmailAddress = _data["userEmailAddress"];
            this.cardDetails = _data["cardDetails"] ? CreditCardDetailsDto.fromJS(_data["cardDetails"]) : new CreditCardDetailsDto();
            this.saveTokenizeCard = _data["saveTokenizeCard"];
        }
    }

    static fromJS(data: any): BeginRegisterCreditCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BeginRegisterCreditCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userEmailAddress"] = this.userEmailAddress;
        data["cardDetails"] = this.cardDetails ? this.cardDetails.toJSON() : <any>undefined;
        data["saveTokenizeCard"] = this.saveTokenizeCard;
        return data; 
    }

    clone(): BeginRegisterCreditCardRequest {
        const json = this.toJSON();
        let result = new BeginRegisterCreditCardRequest();
        result.init(json);
        return result;
    }
}

export interface IBeginRegisterCreditCardRequest {
    userId: string | undefined;
    userEmailAddress: string | undefined;
    cardDetails: ICreditCardDetailsDto;
    saveTokenizeCard?: boolean | undefined;
}

export class BeginRegisterCreditCardResponse implements IBeginRegisterCreditCardResponse {
    errorCode?: string | undefined;
    htmlCode?: string | undefined;
    success?: boolean;
    paymentRefenceNumber?: string | undefined;
    message?: string | undefined;

    constructor(data?: IBeginRegisterCreditCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.htmlCode = _data["htmlCode"];
            this.success = _data["success"];
            this.paymentRefenceNumber = _data["paymentRefenceNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BeginRegisterCreditCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeginRegisterCreditCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["htmlCode"] = this.htmlCode;
        data["success"] = this.success;
        data["paymentRefenceNumber"] = this.paymentRefenceNumber;
        data["message"] = this.message;
        return data; 
    }

    clone(): BeginRegisterCreditCardResponse {
        const json = this.toJSON();
        let result = new BeginRegisterCreditCardResponse();
        result.init(json);
        return result;
    }
}

export interface IBeginRegisterCreditCardResponse {
    errorCode?: string | undefined;
    htmlCode?: string | undefined;
    success?: boolean;
    paymentRefenceNumber?: string | undefined;
    message?: string | undefined;
}

export class CreditCardRegistrationDto implements ICreditCardRegistrationDto {
    id?: number;
    userId?: string | undefined;
    cardNumberFirstFourDigits?: string | undefined;
    cardNumberLastFourDigits?: string | undefined;
    cardName?: string | undefined;
    cardTypeId?: string | undefined;
    cardCurrencyCode?: string | undefined;
    isConfirmationAttemptsExceeded?: boolean;
    isConfirmed?: boolean;
    wasSaved?: boolean;
    billingAddress?: AddressDto;

    constructor(data?: ICreditCardRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.billingAddress = data.billingAddress && !(<any>data.billingAddress).toJSON ? new AddressDto(data.billingAddress) : <AddressDto>this.billingAddress; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.cardNumberFirstFourDigits = _data["cardNumberFirstFourDigits"];
            this.cardNumberLastFourDigits = _data["cardNumberLastFourDigits"];
            this.cardName = _data["cardName"];
            this.cardTypeId = _data["cardTypeId"];
            this.cardCurrencyCode = _data["cardCurrencyCode"];
            this.isConfirmationAttemptsExceeded = _data["isConfirmationAttemptsExceeded"];
            this.isConfirmed = _data["isConfirmed"];
            this.wasSaved = _data["wasSaved"];
            this.billingAddress = _data["billingAddress"] ? AddressDto.fromJS(_data["billingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditCardRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["cardNumberFirstFourDigits"] = this.cardNumberFirstFourDigits;
        data["cardNumberLastFourDigits"] = this.cardNumberLastFourDigits;
        data["cardName"] = this.cardName;
        data["cardTypeId"] = this.cardTypeId;
        data["cardCurrencyCode"] = this.cardCurrencyCode;
        data["isConfirmationAttemptsExceeded"] = this.isConfirmationAttemptsExceeded;
        data["isConfirmed"] = this.isConfirmed;
        data["wasSaved"] = this.wasSaved;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CreditCardRegistrationDto {
        const json = this.toJSON();
        let result = new CreditCardRegistrationDto();
        result.init(json);
        return result;
    }
}

export interface ICreditCardRegistrationDto {
    id?: number;
    userId?: string | undefined;
    cardNumberFirstFourDigits?: string | undefined;
    cardNumberLastFourDigits?: string | undefined;
    cardName?: string | undefined;
    cardTypeId?: string | undefined;
    cardCurrencyCode?: string | undefined;
    isConfirmationAttemptsExceeded?: boolean;
    isConfirmed?: boolean;
    wasSaved?: boolean;
    billingAddress?: IAddressDto;
}

export class ConfirmCreditCardRegistrationRequestBody implements IConfirmCreditCardRegistrationRequestBody {
    amountCharged!: number;

    constructor(data?: IConfirmCreditCardRegistrationRequestBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountCharged = _data["amountCharged"];
        }
    }

    static fromJS(data: any): ConfirmCreditCardRegistrationRequestBody {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmCreditCardRegistrationRequestBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountCharged"] = this.amountCharged;
        return data; 
    }

    clone(): ConfirmCreditCardRegistrationRequestBody {
        const json = this.toJSON();
        let result = new ConfirmCreditCardRegistrationRequestBody();
        result.init(json);
        return result;
    }
}

export interface IConfirmCreditCardRegistrationRequestBody {
    amountCharged: number;
}

export class ReferenceValueDto implements IReferenceValueDto {
    id?: string | undefined;
    description?: string | undefined;

    constructor(data?: IReferenceValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ReferenceValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data; 
    }

    clone(): ReferenceValueDto {
        const json = this.toJSON();
        let result = new ReferenceValueDto();
        result.init(json);
        return result;
    }
}

export interface IReferenceValueDto {
    id?: string | undefined;
    description?: string | undefined;
}

export class VerifyFirstAtlanticPaymentResponse implements IVerifyFirstAtlanticPaymentResponse {
    errorCode?: string | undefined;
    paymentRefenceNumber?: string | undefined;
    success?: boolean;
    message?: string | undefined;
    receipt?: BillOfLadingReceiptDto;
    requestHost?: string | undefined;

    constructor(data?: IVerifyFirstAtlanticPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.receipt = data.receipt && !(<any>data.receipt).toJSON ? new BillOfLadingReceiptDto(data.receipt) : <BillOfLadingReceiptDto>this.receipt; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.paymentRefenceNumber = _data["paymentRefenceNumber"];
            this.success = _data["success"];
            this.message = _data["message"];
            this.receipt = _data["receipt"] ? BillOfLadingReceiptDto.fromJS(_data["receipt"]) : <any>undefined;
            this.requestHost = _data["requestHost"];
        }
    }

    static fromJS(data: any): VerifyFirstAtlanticPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyFirstAtlanticPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["paymentRefenceNumber"] = this.paymentRefenceNumber;
        data["success"] = this.success;
        data["message"] = this.message;
        data["receipt"] = this.receipt ? this.receipt.toJSON() : <any>undefined;
        data["requestHost"] = this.requestHost;
        return data; 
    }

    clone(): VerifyFirstAtlanticPaymentResponse {
        const json = this.toJSON();
        let result = new VerifyFirstAtlanticPaymentResponse();
        result.init(json);
        return result;
    }
}

export interface IVerifyFirstAtlanticPaymentResponse {
    errorCode?: string | undefined;
    paymentRefenceNumber?: string | undefined;
    success?: boolean;
    message?: string | undefined;
    receipt?: IBillOfLadingReceiptDto;
    requestHost?: string | undefined;
}

export class PayPalPaymentMethodDto extends PaymentMethodDto implements IPayPalPaymentMethodDto {
    referenceNumber?: string | undefined;

    constructor(data?: IPayPalPaymentMethodDto) {
        super(data);
        this._discriminator = "PayPalPaymentMethodDto";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referenceNumber = _data["referenceNumber"];
        }
    }

    static fromJS(data: any): PayPalPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber;
        super.toJSON(data);
        return data; 
    }

    clone(): PayPalPaymentMethodDto {
        const json = this.toJSON();
        let result = new PayPalPaymentMethodDto();
        result.init(json);
        return result;
    }
}

export interface IPayPalPaymentMethodDto extends IPaymentMethodDto {
    referenceNumber?: string | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}